import React, { useEffect, useRef, useState } from "react";
import styles from "./styles.module.css";
import clsx from "clsx";
import gamePlayBg from "../../assets/gameplay-bg.svg"
import { getWindowInnerDimensions } from "../../utils/WindowDimensions";
import BoardNx from "../../assets/svgs/gameplay/BoardNx";
import CoinAnimation from "../../components/GamePlayComponents/CoinAnimation";
import GameplayHeader from "../../components/GamePlayComponents/GameplayHeader";
import MovesAndScore from "../../components/GamePlayComponents/MovesAndScore";
import GameFeed from "../../components/GamePlayComponents/GameFeed";
import Boxes from "../../components/GamePlayComponents/Boxes";
import MovingKukari from "../../components/GamePlayComponents/MovingKukari";
import { getWidth } from "../../utils/relativeSizes";
import Dice from "../../components/GamePlayComponents/dice";
import useSafeAreaInsets from "../../hooks/useSafeAreaInsets";
import KilledKukari from "../../components/GamePlayComponents/KilledKukari";
import { createEventProcessor, getEventProcessor } from "./eventProcessor";
import { LB_UPDATE_TABLE_INFO } from "../../store/reduxConstants";
import { store } from "../../store";
import { useSelector } from "react-redux";
import { getAllKukariPositions, getDiceValue, getPlayersInfo } from "../../store/selectors/ludoboardSelectors";
// import { connectSocket } from "../../classes/socket/gameplay";
import StartGameAnimation from "../../components/GamePlayComponents/GamePlayAnimations/StartGameAnimation";
import EndGameAnimation from "../../components/GamePlayComponents/GamePlayAnimations/EndGameAnimation";
import TripleSixAnimation from "../../components/GamePlayComponents/GamePlayAnimations/TripleSixAnimation";
import ExtraMoveAnimation from "../../components/GamePlayComponents/GamePlayAnimations/ExtraMoveAnimation";
import HomeAnimation from "../../components/GamePlayComponents/GamePlayAnimations/HomeAnimation";
import SmokeAnimation from "../../components/GamePlayComponents/SmokeAnimation";
import ScoreFlyAnimationWrapper from "../../components/GamePlayComponents/ScoreFlyAnimationWrapper";
import UserInfo from "../../components/GamePlayComponents/UserInfo";
import { PLAYER_NUMBER } from "./types";
import KukariRevealAnimation from "../../components/GamePlayComponents/KukariRevealAnimation";
import KukariScoreNudge from "../../components/GamePlayComponents/KukariScoreNudge";
import TimeBank from "../../components/GamePlayComponents/TimeBank";
import { useLocation, useNavigate } from "react-router-dom";
import { stopRunningMusic } from "../../classes/sound";
import { isSocketConnected } from "../../classes/socket/gameplay";
import { NAVIGATION_ROUTES } from "../../constant";
import { FbPixelEvent_PageView } from "../../utils/FbPixel/fbPixel";
import { getPartnerId } from "../../utils/helpers/common";
import { FACEBOOK } from "../../utils/helpers/constants";

export enum GAMES {
  LUDONX = 'LUDONX'
}
const { dispatch, getState } = store

const GamePlay = () => {
    const [windowSize, setWindowSize] = useState(getWindowInnerDimensions());
    const {top} = useSafeAreaInsets();
    const location = useLocation();
    const navigate = useNavigate();

    const data = useSelector(getAllKukariPositions)

    const hasTrackedRef = useRef(false);
  
    useEffect(() => {
      if (getPartnerId() === FACEBOOK && !hasTrackedRef.current) {
        hasTrackedRef.current = true;
        FbPixelEvent_PageView();
      }
    }, []);
  
    useEffect(() => {
      const handleResize = () => {
        setWindowSize(getWindowInnerDimensions());
      };
  
      window.addEventListener("resize", handleResize);
  
      return () => {
        window.removeEventListener("resize", handleResize);
      };
    }, []);

    useEffect(() => {
      // Cleanup function called when component unmounts or when location changes
      return () => {
        stopRunningMusic();
      };
    }, [location]); 

    useEffect(() => {
      if(!isSocketConnected()) {
        navigate(NAVIGATION_ROUTES.HOME, {replace: true})
      }
    }, [navigate])
    
  return (
    <>
      <div 
        className={clsx(styles.boardBg)} 
        style={{ 
          backgroundImage: `url(${gamePlayBg})`, 
          width: `${windowSize.width}px`, 
          height: `${windowSize.height}px`
        }}>
        <GameplayHeader />
        <MovesAndScore />
        <div className={clsx(styles.gameFeedContainer, "flex alignItemCenter justifyContentCenter")}>
          <GameFeed />
        </div>
        <ScoreFlyAnimationWrapper playerNumber={PLAYER_NUMBER.ONE} />
        <div className={clsx(styles.boardContainer)}>
          <BoardNx
            className={clsx(styles.nxBoardSvg)}
            width={getWidth(360)}
            height={getWidth(380)}
          />
          <Boxes /> 
          <MovingKukari />
          <KilledKukari />
          <StartGameAnimation />
          <EndGameAnimation />
          <TripleSixAnimation />
          <KukariRevealAnimation />
          <HomeAnimation />
          <SmokeAnimation />
          <ExtraMoveAnimation />
          <UserInfo />
        </div>
        <KukariScoreNudge />
        <Dice />
        <TimeBank />
        <CoinAnimation />
      </div>
    </>
  );
};

export default GamePlay;
